var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"auth_wallet"}},[_c('unicon',{attrs:{"height":"100px","name":"keyhole-circle","width":"100px"}}),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('authentificateUnlock.header')))])]),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.$t('authentificateUnlock.body'))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }